module.exports = "/fonts/fa-regular-400.eot?c530c69d2821c1ab9202edfeee81f085";